import React from "react";
import GiftBox from "../../../images/baf_asset.png";
import { useNavigate } from "react-router-dom";
import { Button } from "@heroui/react";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";

const HeroSection = ({ scrollToProduct }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/marketplace");
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="left-sdie-wrapper">
          <div className="content pb-8">
            <h1>
              <span>Discover Digital</span> <br />
              Arts and Collect
            </h1>
            <h6>NFTs</h6>
            <p className="!mb-4">
              BAF creates a new market for artists by transforming their
              masterpieces into unique Real World Assets (RWAs). By partnering
              with BAF, artists earn a fair percentage from each RWA sale and
              receive royalties from secondary market transactions.
            </p>
            <Button
              className="bg-yellowbuy text-black rounded-lg"
              endContent={<ArrowLongRightIcon className="w-6 h-6" />}
              onPress={scrollToProduct}
            >
              Buy Now
            </Button>
          </div>
        </div>
        <div className="right-sdie-wrapper">
          <div className="relative mx-auto max-w-[38rem] w-full flex flex-col items-center">
            <img
              alt="Logo"
              src={GiftBox}
              className="w-full h-auto object-contain"
              loading="eager"
            />

            {/* Dotted line */}
            <div className="w-[2px] h-10 border-l-2 border-dashed border-yellowbuy my-2"></div>

            {/* Explore Button */}
            <Button
              onPress={handleNavigate}
              className="animate-blink bg-black text-yellowbuy w-24 h-10 border border-black rounded-[0.625rem] uppercase text-base font-semibold"
            >
              Explore
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
